import moment from "moment";
import momentTz from "moment-timezone";
import {objectVariable} from "@/js/document/document";
import {stripHtml} from "../utils";

const regex = /\${([^{}]*)}/g;

String.prototype.hasOwnProperty("interpolate") && Object.defineProperty(String.prototype, 'interpolate', {
    value: function (variables, fallback) {
        return this.replace(regex, (match) => {
            const path = match.slice(2, -1).trim();
            return getObjPath(path, variables, fallback);
        });
    },
    enumerable: false,
    writable: false
});

function getObjPath(path, obj, fallback = '') {
    return path.split('.').reduce((res, key) => res[key] || fallback, obj);
}

String.prototype.hasOwnProperty("writeLine") && Object.defineProperty(String.prototype, 'writeLine', {
    value: function (text) {
        return this.concat(text, '\r\n');
    },
    enumerable: false,
    writable: false
});

const checkForFunction = function (path) {
    let conversionType = "number";
    let defaultValue;
    let conversionIndex = path.indexOf('.toFixed');

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('.toTimezone');
        if (conversionIndex >= 0)
            conversionType = "datetimezone";
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('.formatDate');
        if (conversionIndex >= 0)
            conversionType = "date";
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('.subtract');
        if (conversionIndex >= 0)
            conversionType = "subtract";
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('.splitDigits');
        if (conversionIndex >= 0)
            conversionType = "splitDigits";
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('.findArrayItem');
        if (conversionIndex >= 0) {
            conversionType = "findArrayItem";
        }
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('.arrayContainsItem');
        if (conversionIndex >= 0) {
            conversionType = "arrayContainsItem";
        }
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('.defaultValue');
        if (conversionIndex >= 0) {
            defaultValue = path.substring(conversionIndex + ".defaultValue(".length, path.length - 1);
            if (typeof defaultValue === 'string')
                defaultValue = defaultValue.replace(/"/g, "");
            path = path.replace(path.substring(conversionIndex, path.length), '');
        }
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('calculate(');
        if (conversionIndex >= 0)
            conversionType = "calculate";
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('concat(');
        if (conversionIndex >= 0)
            conversionType = "concat";
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('concatSeparator(');
        if (conversionIndex >= 0)
            conversionType = "concatSeparator";
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('ifEmptyOrNull(');
        if (conversionIndex >= 0)
            conversionType = "ifEmptyOrNull";
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('ifElse(');
        if (conversionIndex >= 0)
            conversionType = "ifElse";
    }

    if (conversionIndex < 0) {
        conversionIndex = path.indexOf('checkCondition(');
        if (conversionIndex >= 0) {
            conversionType = "checkCondition";
        }
    }

    const conversion = conversionIndex >= 0 ? path.substring(conversionIndex, path.length) : null;
    path = path.replace(conversion, '');
    return {newPath: path, conversion: conversion, conversionType: conversionType, defaultValue};
};

/**
 * Executes a custom method
 * @param {String} functionName
 * @param {String} params
 * @returns {String}
 */
const callFunction = function (functionName, params) {
    let result;
    switch (functionName) {
        case 'calculate':
            try {
                result = eval(params);
            } catch (e) {
                result = params
            }
            break
        case 'concat':
            result = params
                .split(",")
                .filter(el => el)
                .map(el => {
                    return el.trim();
                })
                .join(" ");
            break
        case 'checkCondition':
            try {
                result = eval(params);
            } catch (e) {
                result = params
            }
            break
        default:
            result = params
            break
    }
    return result
}

/**
 * Extract functions from input and update input with parsed result
 * @param {String} input
 * @param {Object} variables
 * @returns {String}
 */
const parseFunctionCall = function (input, variables) {
    const regex = /(\w+)\s*\(\s*(.*?)\s*\)\s*/gm;
    let m;
    let toReplace = [];
    let functions = [];
    let params = [];

    while ((m = regex.exec(input)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (m.index === regex.lastIndex) {
            regex.lastIndex++;
        }
        // The result can be accessed through the `m`-variable.
        m.forEach((match, groupIndex) => {
            //console.log(`Found match, group ${groupIndex}: ${match}`);
            if (groupIndex === 0) {
                toReplace.push(match);
            }
            if (groupIndex === 1) {
                functions.push(match);
            }
            if (groupIndex === 2) {
                params.push(match);
            }
        });
    }

    if (toReplace.length) {
        for (let i = 0; i < toReplace.length; i++) {
            input = input.replace(toReplace[i], callFunction(functions[i], params[i].interpolateObject(variables)));
        }
    }

    return input;
}

Object.defineProperty(String.prototype, 'interpolateObject', {
    value: function (variables, fallback = '') {
        let response;
        // parse functions like customFunction(input) first, and then continue with interpolation
        //let str = parseFunctionCall(this, variables);
        let stringResponse = this.replace(regex, (match) => {
            let paramResult;
            let param;

            let path = match.slice(2, -1).trim();
            path = stripHtml(path);
            /*var conversionIndex = path.indexOf('.toFixed');
            var conversion = conversionIndex > 0 ? path.substring(conversionIndex, path.length) : null;
            path = path.replace(conversion, '');*/
            let {newPath, conversion, conversionType, defaultValue} = checkForFunction(path);
            let result = newPath.getObjDeepPath(variables) || objectVariable(variables, newPath);

            if (result && conversion) {
                if (conversionType === "date")
                    result = eval('("' + result.toString() + '")' + conversion);
                else if (conversionType === "datetimezone") {
                    //conversion = conversion.getObjDeepPath(variables);
                    const commaIndex = conversion.indexOf(',');
                    param = conversion.substring(12, commaIndex);
                    paramResult = param.getObjDeepPath(variables);
                    conversion = conversion.replace(param, "'" + paramResult + "'");
                    result = eval('("' + result.toString() + '")' + conversion);
                } else if (conversionType === "subtract") {
                    param = conversion.substring(9, conversion.length - 1);
                    paramResult = param.getObjDeepPath(variables);
                    result = (result ? result : 0) - (paramResult ? paramResult : 0);
                } else if (conversionType === "splitDigits") {
                    result = eval('("' + result.toString() + '")' + conversion);
                }
                else if (conversionType === "findArrayItem") {
                    result = eval('(' + 'JSON.stringify(result)' + ')' + conversion);
                }
                else if (conversionType === "arrayContainsItem") {
                    result = eval('(' + 'JSON.stringify(result)' + ')' + conversion);
                }
                else if (conversionType === "checkCondition") {
                    result = eval('("' + result.toString() + '")' + conversion);
                }
                else
                    result = eval('(' + result.toString() + ')' + conversion);
            } else if (conversionType) {
                if (conversionType === "calculate") {
                    try {
                        result = eval(conversion.replace('calculate(', '').replace(/\)$/, ''));
                    } catch (e) { }
                }
                if (conversionType === "concat") {
                    let concatParams = conversion.replace('concat(', '').replace(/\)$/, '');
                    result = concatParams
                        .split(",")
                        .filter(el => el)
                        .map(el => {
                            return el.trim();
                        })
                        .join(" ");
                }
                else if (conversionType === "concatSeparator") {
                    let concatParams = conversion.replace('concatSeparator(', '').replace(/\)$/, '');
                    let splittedFields = concatParams.split(/\,[^ ]/);
                    result = splittedFields?.filter((el, index) => el && index > 0)
                        .map(el => {
                            return el.trim().replaceAll("'", '');
                        })
                        .filter(el => el)
                        .join(splittedFields?.length ? splittedFields[0].replaceAll("'", '') : ' ');
                }
                else if (conversionType === "ifEmptyOrNull") {
                    let params = conversion.match(/[^=ifEmptyOrNull](.*?)\?\?(.*?)\)/g)
                    if (params && params.length)
                        result = params[0] ? params[0] : params[1]
                }
                else if (conversionType === "ifElse") {
                    const rgx = /[^=ifElse](.*?)\?(.*?):(.*?)\)/g;
                    let params = rgx.exec(conversion)
                    if (params && params.length)
                        result = eval(params[0])
                }
                if (conversionType === "checkCondition") {
                    try {
                        result = eval(conversion.replace('checkCondition(', '').replace(/\)$/, ''));
                    } catch (e) { }
                }
            }

            if (typeof result === "undefined" || result === null)
                if (!result && defaultValue)
                    result = defaultValue;

            result = typeof result !== 'undefined' && result !== null ? result : fallback;
            response = result;
            return result;
        });

        if (stringResponse.match(regex)) {
            return stringResponse.interpolateObject(variables, fallback)
        } /*else {
      return stringResponse
    }*/
        if (typeof stringResponse !== "undefined" && typeof response !== "undefined" && stringResponse !== response?.toString())
            response = stringResponse;

        return typeof response === "undefined" ? this : response;
    },
    enumerable: false,
    writable: false,
    configurable: true
});

if (!String.prototype.hasOwnProperty('formatDate'))
Object.defineProperty(String.prototype, 'formatDate', {
    value: function (pattern, locale = 'en') {
        return moment(this).locale(locale).format(pattern);
    },
    enumerable: false,
    writable: false
});

if (!String.prototype.hasOwnProperty('toTimezone'))
Object.defineProperty(String.prototype, 'toTimezone', {
    value: function (timezone, format) {
        return momentTz(this).tz(timezone).format(format);
    },
    enumerable: false,
    writable: false
});

if (!String.prototype.hasOwnProperty('splitDigits'))
Object.defineProperty(String.prototype, 'splitDigits', {
    value: function (digitNo, separator) {
        return this.split('').reverse().join('').match(new RegExp(`.{1,${digitNo}}`, 'g')).join(separator ? separator : ' ').split('').reverse().join('');
    },
    enumerable: false,
    writable: false
});

//const squareRegex = /\[(.*?)\]/g;
if (!String.prototype.hasOwnProperty('getObjDeepPath'))
Object.defineProperty(String.prototype, 'getObjDeepPath', {
    value: function (obj) {
        //if(isJsonString(obj)) obj = JSON.parse(obj)
        let deepObjects = this.replace(regex, (match) => {
            const squarePath = match.slice(1, -1).trim();
            return '.' + squarePath.getObjDeepPath(obj);
        });
        let i = 0;
        deepObjects = deepObjects.split('.');
        const len = deepObjects.length;
        for (; i < len; i++) {
            if (typeof obj[deepObjects[i].replace(/[\[\]']+/g, '')] === "undefined" || obj[deepObjects[i].replace(/[\[\]']+/g, '')] === null)
                return null;
            else
                obj = obj[deepObjects[i].replace(/[\[\]']+/g, '')];
        }
        return obj;
    },
    enumerable: false,
    writable: false
});

if (!String.prototype.hasOwnProperty('validateEmail'))
Object.defineProperty(String.prototype, 'validateEmail', {
    value: function () {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(this);
    },
    enumerable: false,
    writable: false
});

if (!String.prototype.hasOwnProperty('capitalize'))
Object.defineProperty(String.prototype, 'capitalize', {
    value: function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
    },
    enumerable: false,
    writable: false
});

if (!String.prototype.hasOwnProperty('uncapitalize'))
Object.defineProperty(String.prototype, 'uncapitalize', {
    value: function () {
        return this.charAt(0).toLowerCase() + this.slice(1);
    },
    enumerable: false,
    writable: false
});

if (!String.prototype.hasOwnProperty('findArrayItem'))
Object.defineProperty(String.prototype, 'findArrayItem', {
    value: function (conditions, field) {
        let result;
        let filters = {};
        let functions = []
        let list = JSON.parse(this);
        if (list) {
            conditions.forEach(condition => {
                let split = condition.split(":");
                filters[split[0]] = item => item[split[0]] == split[1];
                functions.push(filters[split[0]])
            })
            result = list.find(item => functions.every(f => f(item)));
        }
        if (result && field) result = objectVariable(result, field);
        return result;
    },
    enumerable: false,
    writable: false
});

if (!String.prototype.hasOwnProperty('arrayContainsItem'))
Object.defineProperty(String.prototype, 'arrayContainsItem', {
    value: function (conditions, field) {
        let result;
        let filters = {};
        let functions = []
        let list = JSON.parse(this);
        if (list) {
            conditions.forEach(condition => {
                let split = condition.split(":");
                filters[split[0]] = item => item[split[0]] == split[1];
                functions.push(filters[split[0]])
            })
            result = list.find(item => functions.every(f => f(item)));
        }
        if (result) return true
        return false;
    },
    enumerable: false,
    writable: false
});

if (!String.prototype.hasOwnProperty('checkCondition'))
Object.defineProperty(String.prototype, 'checkCondition', {
    value: function (condition, trueValue, falseValue) {
        if (condition)
            return trueValue;
        return falseValue;
    },
    enumerable: false,
    writable: false
});

export default {}
